import { ISLEntryGridItem } from "../../schemas/SLEntryGridSchemas";
import { Selection } from "@fluentui/react";
import { ActionTypesForSLSearch } from "../SLActionsManager/SLActionsManagerTypes";
import { IProcessingStatus } from "../SLEntriesDetails";
import WeightageCalculator from "../../utilities/WeightageCalculator";
import { IWeightages } from "../../contexts/dataFetchers/actionLinks";
import { RuntimeError } from "../../services/ErrorHelpers";
import { leftPadDocumentNumber } from "../../utilities/utilities";

export enum GridCommandToggle {
  Enabled = "Enabled",
  Disabled = "Disabled",
  Removed = "Removed"
}

export interface ToDeletePayloads {
  slEntryIds: number[];
  slBatchRefGuids: string[];
}

export function slEntryGridItemsToEntryIdsAndBatchRefGuids(
  items: Array<Pick<ISLEntryGridItem, "slEntryId" | "statusId" | "status" | "batchRefguid">>
): ToDeletePayloads {
  return items.reduce(
    (ctr, item) => {
      if (item.status === "ValidationFailed" && item.batchRefguid) {
        ctr.slBatchRefGuids.push(item.batchRefguid);
      } else {
        ctr.slEntryIds.push(item.slEntryId);
      }
      return ctr;
    },
    { slEntryIds: [], slBatchRefGuids: [] } as ToDeletePayloads
  );
}

export function slEntryGridItemsToEntryIds(items: Array<Pick<ISLEntryGridItem, "slEntryId">>): number[] {
  const ids = items.map((gridRow) => gridRow.slEntryId);
  return ids;
}
export function selectionToEntryIds(selection: Selection): number[] {
  return slEntryGridItemsToEntryIds(selection.getSelection() as ISLEntryGridItem[]);
}

export function selectionToEntry(selection: Selection): ISLEntryGridItem[] {
  return selection.getSelection() as ISLEntryGridItem[];
}

const ActionTypeToDisableButton = {
  Post: "disablePostButton",
  AddPosters: "disableAddPostersButton",
  SendToPoster: "disableSendToPosterButton",
  NeedClarification: "disableNeedsClarificationButton",
  ApproveEntries: "disableApproveButton",
  RecallEntries: "disableRecallButton",
  Delete: "disableDeleteButton",
  AddAttachments: "disableAttachmentsButton",
  DeleteAttachments: "disableAttachmentsButton"
};

export function validateEntriesForAction(
  weightages: IWeightages,
  actionName: ActionTypesForSLSearch,
  entries: ISLEntryGridItem[]
): IProcessingStatus["statuses"] | null {
  const actionFunctionName = ActionTypeToDisableButton[actionName];
  if (actionFunctionName in WeightageCalculator) {
    const statuses = entries.reduce((statuses, entry) => {
      const isButtonDisabledForEntry = WeightageCalculator[actionFunctionName as keyof typeof WeightageCalculator](
        weightages,
        {
          entryId: entry.slEntryId,
          rowWeightage: entry.rowWeightage
        }
      );
      if (isButtonDisabledForEntry) {
        const nameDocumentId = entry.nameDocumentId || leftPadDocumentNumber(entry.slEntryId);
        statuses[entry.slEntryId] = {
          type: "error",
          messages: [`Selected Action "${actionName}" cannot be performed on this Entry.`],
          nameDocumentId
        };
      }
      return statuses;
    }, {} as IProcessingStatus["statuses"]);
    if (Object.keys(statuses).length === 0) {
      return null;
    }
    return statuses;
  } else {
    throw new RuntimeError(`Action type ${actionName} is not supported.`);
  }
}

export function processingStatusToListOfListOfEntries(processingStatus: IProcessingStatus["statuses"]): string[] {
  const ENTRIES_PER_ROW = 5;

  const invalidEntries = Object.keys(processingStatus).reduce((listOfList, entryId) => {
    const msg = `SL_${entryId}`;
    if (listOfList.length === 0) {
      listOfList.push([msg]);
    } else if (listOfList[listOfList.length - 1].length === ENTRIES_PER_ROW) {
      listOfList.push([msg]);
    } else {
      listOfList[listOfList.length - 1].push(msg);
    }
    return listOfList;
  }, [] as string[][]);
  return invalidEntries.map((listOfInvalidEntries) => listOfInvalidEntries.join(", "));
}
